import { memo } from 'react'
import { TranslatedLiveSportItem } from '../../util/live'
import SportIcon from './SportIcon'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper/modules'

const GamesListSportFilterItem = memo<{
  sport: TranslatedLiveSportItem
  activeSportId: number
  setActiveSportId: (sportId: number) => void
  showOpenGameCount: boolean
}>(
  ({ sport, activeSportId, setActiveSportId, showOpenGameCount }) => {
    return (
      <div
        className={`games-list-sport-filter-item flex space-x-2 items-center px-4 py-2 rounded-full whitespace-nowrap transition-colors cursor-pointer ${
          sport.id === activeSportId
            ? 'games-list-sport-filter-item-active bg-primary text-primaryContrast'
            : 'bg-gray-500 bg-opacity-10 hover:bg-opacity-20'
        }`}
        onClick={() => setActiveSportId(sport.id)}
      >
        <SportIcon sportShortSign={sport.shortSign} height="16px" width="16px" />
        <span className="games-list-sport-filter-item-name text-xs font-semibold">{sport.name}</span>
        {showOpenGameCount && sport.openGameCount != null && (
          <span className="games-list-sport-filter-item-gamecount text-xs">{sport.openGameCount}</span>
        )}
      </div>
    )
  },
  (prevProps, nextProps) =>
    prevProps.activeSportId === nextProps.activeSportId &&
    prevProps.sport.id === nextProps.sport.id &&
    prevProps.sport.openGameCount === nextProps.sport.openGameCount,
)

export const GamesListSportFilter = ({
  sports,
  activeSportId,
  setActiveSportId,
  showOpenGameCount = true,
  className = '',
}) => {
  return (
    <div className={'games-list-sport-filter flex space-x-2 relative overflow-hidden px-2 py-3 ' + className}>
      <Swiper
        className="games-list-sport-filter-swiper w-full"
        wrapperClass="flex space-x-2"
        modules={[FreeMode]}
        slidesPerView={'auto'}
        freeMode
      >
        {sports?.map((sport) => (
          <SwiperSlide className="games-list-sport-filter-swiper-slider !w-auto " key={sport.id}>
            <GamesListSportFilterItem
              sport={sport}
              activeSportId={activeSportId}
              setActiveSportId={setActiveSportId}
              showOpenGameCount={showOpenGameCount}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
